/* -------------------------------------------------------------------------- */
/* Shadow-root integration for all HTML skins                                 */
/* -------------------------------------------------------------------------- */

/* Resets and component styles come from the skins package. This file only bridges the host and its slotted media. */

:host {
  /* `display:grid` fixes a weird issue with Safari when setting aspect-ratio */
  display: grid;
  width: 100%;
}

:host(:focus) {
  /* The host matches :focus when a shadow control is focused; keep page styles from adding a second ring. */
  outline: none !important;
}

/* Media fills the skin; important keeps page styles from adding internal spacing. */
::slotted(video),
::slotted(audio) {
  margin: 0 !important;
}
